import React, { useState } from 'react'
import { useDispatch, } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  unpublishPost,
  goToPost, loadGroupPosts
}
  from 'state/actions/posts'
import { pinIntroToGroup } from 'state/actions/groups'

import ArticleList from 'components/ArticleList'
import Menu from 'components/Menu'
// import MenuItem from 'components/MenuItem'
import GroupTertiaryError from './GroupTertiaryError'
import LandingPageLink from './LandingPageLink'
import { usePosts } from 'posts/posts.selectors'
import { ReactFC } from 'types'
import { useCircle, useCircleMembership } from 'circle/circle.selectors'
import { useProfile } from 'profile'
import LoadingPlaceholder from 'components/LoadingPlaceholder'
import { Post } from 'posts/posts.types'
import { User } from 'profile/profile.types'
import { Circle, CircleMembership } from 'circle/circle.types'
import { isAuthor, isAdmin } from '../../posts/isAdmin'
import {
  useApi,
  MoveAssetDialog,
} from "lib-core"
import { useCirclePostItemsFn } from 'lib-core'

export interface PostsListProps {
  content: Record<string, Post>
  order: string[]
  onLoadPosts: any
  profile: User
  group: Circle
  membership: CircleMembership
}
export interface PostsListHandlers {
  onPostClick,
}

const PostList: ReactFC<PostsListProps & PostsListHandlers> = (props) => {
  const hasOverflowMenu = (target: Post) => {
    const { profile, membership, group } = props
    return isAuthor(target, profile) || (isAdmin(membership) && !group.closed)
  }

  const renderOverflowMenu = useCirclePostItemsFn()

  return (
    <ArticleList
      {...props}
      overflowMenu={renderOverflowMenu}
      hasOverflowMenu={hasOverflowMenu}
    />
  )
}

export const PostsSection: ReactFC = () => {
  const api = useApi()
  const posts = usePosts()
  const group = useCircle()
  const membership = useCircleMembership()
  const { profile } = useProfile()

  const [move, setMove] = useState<Post>(null)
  const {
    dispatch,
    onPostClick,
    onLoadPosts
  } = useAPI()

  const { map: content, list } = posts
  
  const { loading, error, values: order } = list || {}

  if (error) {
    return <GroupTertiaryError error={error} />
  }

  if (loading || !content) {
    return <LoadingPlaceholder />
  }

  const loaded: PostsListProps = {
    content,
    order,
    onLoadPosts,
    profile,
    group,
    membership
  }

  return (
    <>
      <LandingPageLink />
      <PostList
        onPostClick={onPostClick}
        {...loaded}
      />
      <MoveAssetDialog
        open={!!move}
        post={move}
        onClose={() => {
          const load = bindActionCreators(loadGroupPosts, dispatch)
          load({ group: move.group.group._id })
          setMove(null)
        }}
      />
    </>
  )
}

const useAPI = () => {
  const dispatch = useDispatch()
  return {
    dispatch,
    onPostClick: ({ group, _id }) => {
      dispatch(goToPost({ group, _id }))
    },
    onPinAsGroupIntro: bindActionCreators(pinIntroToGroup, dispatch),
    onLoadPosts: bindActionCreators(loadGroupPosts, dispatch)
  }
}

export default PostsSection
